import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Icon,
  Typography,
  Theme,
  useTheme,
  TIcons,
} from "@yuno/design-system-web";
import { MenuItems } from "../../../types";
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  padding-right: 10px;
  padding-left: 10px;
`;

const SideButton = styled.button<{ theme?: Theme; active?: boolean }>`
  width: 100%;
  transition: background 0.3s ease-in-out;
  background: ${({ theme }) => theme.palette.grey[0]};
  padding: 10px;
  border: ${({ active, theme }) => `1px solid ${theme.palette.grey[2]}`};
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  & p {
    margin-top: 10px;
    ${({ theme }) => theme.typography.tiny.regular};
    color: ${({ theme, active }) =>
      active ? theme.palette.grey[5] : theme.palette.grey[3]}!important;
  }
`;

const ItemMenu = styled(Typography)<{ theme?: Theme }>``;

const menu = [
  { id: "CHECKOUT", name: "checkout", icon: "Swatches", active: true },
  { id: "REDIRECTION", name: "redirection", icon: "Monitor" },
  {
    id: "PAYMENT_ENROLLMENT",
    name: "cardEnrollment",
    icon: "CreditCard",
  },
];

export const ToolsSidebarNav = ({ onSelect }) => {
  const theme: Theme = useTheme();
  const { t } = useTranslation()

  const handleChangePage = (page: MenuItems) => onSelect(page);

  return (
    <Wrapper>
      {menu.map((item, key) => (
        <SideButton
          key={key}
          onClick={handleChangePage.bind(null, item.id)}
          active={item.active}
        >
          <Icon
            name={item.icon as TIcons}
            width="50px"
            height="50px"
            weight="thin"
            color={item.active ? theme.palette.grey[5] : theme.palette.grey[3]}
          />
          <ItemMenu>{t(item.name)}</ItemMenu>
        </SideButton>
      ))}
    </Wrapper>
  );
};
